module.exports = __webpack_public_path__ + "img/no-filter.edaf0c72.svg";